module.exports = __webpack_public_path__ + "img/5.3cdf8393.png";